import { render, staticRenderFns } from "./Why.vue?vue&type=template&id=348c0baf&scoped=true"
import script from "./Why.vue?vue&type=script&lang=js"
export * from "./Why.vue?vue&type=script&lang=js"
import style0 from "./Why.vue?vue&type=style&index=0&id=348c0baf&prod&lang=scss"
import style1 from "./Why.vue?vue&type=style&index=1&id=348c0baf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348c0baf",
  null
  
)

export default component.exports